import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../Components/Common/Navbar.js";

import ch1 from "../../Images/KALPIT/characters/1.webp"
import ch2 from "../../Images/KALPIT/characters/2.webp"
import ch3 from "../../Images/KALPIT/characters/3.webp"
import ch4 from "../../Images/KALPIT/characters/4.webp"
import ch5 from "../../Images/KALPIT/characters/5.webp"
import ch6 from "../../Images/KALPIT/characters/6.webp"
import ch7 from "../../Images/KALPIT/characters/7.webp"
import ch8 from "../../Images/KALPIT/characters/8.webp"
import ch9 from "../../Images/KALPIT/characters/9.webp"
import ch10 from "../../Images/KALPIT/characters/10.webp"
import ch11 from "../../Images/KALPIT/characters/11.webp"
import ch12 from "../../Images/KALPIT/characters/12.webp"
import ch13 from "../../Images/KALPIT/characters/13.webp"
import ch14 from "../../Images/KALPIT/characters/14.webp"
import ch15 from "../../Images/KALPIT/characters/15.webp"
import ch16 from "../../Images/KALPIT/characters/16.webp"
import ch17 from "../../Images/KALPIT/characters/17.webp"

import p1 from "../../Images/KALPIT/pillars/1.webp"
import p2 from "../../Images/KALPIT/pillars/2.webp"
import p3 from "../../Images/KALPIT/pillars/3.webp"
import p4 from "../../Images/KALPIT/pillars/4.webp"
import p5 from "../../Images/KALPIT/pillars/5.webp"
import p6 from "../../Images/KALPIT/pillars/6.webp"
import p7 from "../../Images/KALPIT/pillars/7.webp"
import p8 from "../../Images/KALPIT/pillars/8.webp"
import p9 from "../../Images/KALPIT/pillars/9.webp"
import p10 from "../../Images/KALPIT/pillars/10.webp"
import p11 from "../../Images/KALPIT/pillars/11.webp"
import p12 from "../../Images/KALPIT/pillars/12.webp"
import p13 from "../../Images/KALPIT/pillars/13.webp"

import h1 from "../../Images/KALPIT/handhelds/1.webp"
import h2 from "../../Images/KALPIT/handhelds/2.webp"
import h3 from "../../Images/KALPIT/handhelds/3.webp"
import h4 from "../../Images/KALPIT/handhelds/4.webp"
import h5 from "../../Images/KALPIT/handhelds/5.webp"
import h6 from "../../Images/KALPIT/handhelds/6.webp"
import h7 from "../../Images/KALPIT/handhelds/7.webp"
import h8 from "../../Images/KALPIT/handhelds/8.webp"
import h9 from "../../Images/KALPIT/handhelds/9.webp"
import h10 from "../../Images/KALPIT/handhelds/10.webp"
import h11 from "../../Images/KALPIT/handhelds/11.webp"
import h12 from "../../Images/KALPIT/handhelds/12.webp"
import h13 from "../../Images/KALPIT/handhelds/13.webp"

import se1 from "../../Images/KALPIT/scene-elements/1.webp"
import se2 from "../../Images/KALPIT/scene-elements/2.webp"
import se3 from "../../Images/KALPIT/scene-elements/3.webp"
import se4 from "../../Images/KALPIT/scene-elements/4.webp"
import se5 from "../../Images/KALPIT/scene-elements/5.webp"
import se6 from "../../Images/KALPIT/scene-elements/6.webp"
import se7 from "../../Images/KALPIT/scene-elements/7.webp"
import se8 from "../../Images/KALPIT/scene-elements/8.webp"
import se9 from "../../Images/KALPIT/scene-elements/9.webp"
import se10 from "../../Images/KALPIT/scene-elements/10.webp"
import se11 from "../../Images/KALPIT/scene-elements/11.webp"
import se12 from "../../Images/KALPIT/scene-elements/12.webp"
import se13 from "../../Images/KALPIT/scene-elements/13.webp"

import toy1 from "../../Images/KALPIT/toys/1.webp"
import toy2 from "../../Images/KALPIT/toys/2.webp"
import toy3 from "../../Images/KALPIT/toys/3.webp"
import toy4 from "../../Images/KALPIT/toys/4.webp"
import toy5 from "../../Images/KALPIT/toys/5.webp"
import toy6 from "../../Images/KALPIT/toys/6.webp"
import toy7 from "../../Images/KALPIT/toys/7.webp"
import toy8 from "../../Images/KALPIT/toys/8.webp"
import toy9 from "../../Images/KALPIT/toys/9.webp"
import toy10 from "../../Images/KALPIT/toys/10.webp"
import toy11 from "../../Images/KALPIT/toys/11.webp"
import toy12 from "../../Images/KALPIT/toys/12.webp"
// import toy13 from "../../Images/KALPIT/toys/13.webp"

import utensils1 from "../../Images/KALPIT/utensils/1.webp"
import utensils2 from "../../Images/KALPIT/utensils/2.webp"
import utensils3 from "../../Images/KALPIT/utensils/3.webp"
import utensils4 from "../../Images/KALPIT/utensils/4.webp"
import utensils5 from "../../Images/KALPIT/utensils/5.webp"
import utensils6 from "../../Images/KALPIT/utensils/6.webp"
import utensils7 from "../../Images/KALPIT/utensils/7.webp"
import utensils8 from "../../Images/KALPIT/utensils/8.webp"
import utensils9 from "../../Images/KALPIT/utensils/9.webp"
import utensils10 from "../../Images/KALPIT/utensils/10.webp"
import utensils11 from "../../Images/KALPIT/utensils/11.webp"
import utensils12 from "../../Images/KALPIT/utensils/12.webp"
import utensils13 from "../../Images/KALPIT/utensils/13.webp"

// import wearables1 from "../../Images/KALPIT/wearables/1.webp"
// import wearables2 from "../../Images/KALPIT/wearables/2.webp"
// import wearables3 from "../../Images/KALPIT/wearables/3.webp"
// import wearables4 from "../../Images/KALPIT/wearables/4.webp"
// import wearables5 from "../../Images/KALPIT/wearables/5.webp"
// import wearables6 from "../../Images/KALPIT/wearables/6.webp"
// import wearables7 from "../../Images/KALPIT/wearables/7.webp"
// import wearables8 from "../../Images/KALPIT/wearables/8.webp"
// import wearables9 from "../../Images/KALPIT/wearables/9.webp"
// import wearables10 from "../../Images/KALPIT/wearables/10.webp"
// import wearables11 from "../../Images/KALPIT/wearables/11.webp"
// import wearables12 from "../../Images/KALPIT/wearables/12.webp"
// import wearables13 from "../../Images/KALPIT/wearables/13.webp"

import "../../Stylesheets/Research.css";
import topbg from "../../Images/Research/topbg.webp";
import Footer from "../Footer.js";
import KalpitCard from "../../Components/Kalpit/KalpitCard.js";
import Hero from "../../Components/Common/Hero.js";

function Kalpit() {
  const location = useLocation();

  let images = [];
  let title = '';

  if (location.pathname === "/projects/sponsored/kalpit/assets/characters") {
    title = 'Characters';
    images = [
      ch1,
      ch2,
      ch3,
      ch4,
      ch5,
      ch6,
      ch7,
      ch8,
      ch9,
      ch10,
      ch11,
      ch12,
      ch13,
      ch14,
      ch15,
      ch16,
      ch17,
    ];
  } else if (location.pathname === "/projects/sponsored/kalpit/assets/handhelds") {
    title = 'Handhelds';
    images = [
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      h7,
      h8,
      h9,
      h10,
      h11,
      h12,
      h13,
    ];
  } else if (location.pathname === "/projects/sponsored/kalpit/assets/pillars") {
    title = 'Pillars';
    images = [
      p1,
      p2,
      p3,
      p4,
      p5,
      p6,
      p7,
      p8,
      p9,
      p10,
      p11,
      p12,
      p13,
    ];
  } else if (location.pathname === "/projects/sponsored/kalpit/assets/scene-elements") {
    title = 'Scene Elements';
    images = [
      se1,
      se2,
      se3,
      se4,
      se5,
      se6,
      se7,
      se8,
      se9,
      se10,
      se11,
      se12,
      se13,
    ];
  } else if (location.pathname === "/projects/sponsored/kalpit/assets/toys") {
    title = 'Toys';
    images = [
      toy1,
      toy2,
      toy3,
      toy4,
      toy5,
      toy6,
      toy7,
      toy8,
      toy9,
      toy10,
      toy11,
      toy12,
      // toy13,
    ];
  } else if (location.pathname === "/projects/sponsored/kalpit/assets/utensils") {
    title = 'Utensils';
    images = [
      utensils1,
      utensils2,
      utensils3,
      utensils4,
      utensils5,
      utensils6,
      utensils7,
      utensils8,
      utensils9,
      utensils10,
      utensils11,
      utensils12,
      utensils13,
    ];
  } else if (location.pathname === "/projects/sponsored/kalpit/assets/wearables") {
    title = 'Wearables';
    images = [
      // wearables1,
      // wearables2,
      // wearables3,
      // wearables4,
      // wearables5,
      // wearables6,
      // wearables7,
      // wearables8,
      // wearables9,
      // wearables10,
      // wearables11,
      // wearables12,
      // wearables13,
    ];
  }

  return (
    <>
      <div className="min-vh-100">
        <Navbar />
        <br />
        <br />
        <br />

        <Hero
          title={title}
          img={topbg}
          creatorLink="https://unsplash.com/@faded_gallery?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          creator="Faded_Gallery"
          imageLink="https://unsplash.com/photos/a-black-background-with-a-blue-pattern-on-it-MWDDQZO-CIg?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          source="Unsplash"
        />

        <br />
        <br />
        <br />
        {/* <Breadcrumbs /> */}

        <div className="research-content">
          <div className="container">
            <div className="row gy-5">
              {images.map((src, idx) => (
                <div className="col-lg-4 col-md-6">
                  <KalpitCard
                    key={idx}
                    img={src}
                    alt={`Image ${idx}`}
                    // iframe={
                    //   <iframe
                    //     src="https://my.spline.design/clonergridmotioncopy-3133ca9854ef1ed4aff5f1c854c7b93e/"
                    //     frameborder="0"
                    //     width="100%"
                    //     height="100%"
                    //   ></iframe>
                    // }
                    // title="RSUIGM"
                    // id="01"
                    // // link="/dataset_page"
                    // link="https://drive.google.com/drive/folders/1suy4UEUW1T3r39ajzcx8k_0pYvFxFnZ1?usp=share_link"
                    // desc=""
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <br />
        <br />
        <Footer />
      </div>
    </>
  );
}

export default Kalpit;
